import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Building2, Fuel, Home, Cpu, Users, ArrowRight } from 'lucide-react';
import { partners } from '../../data/mock';

const Partners = () => {
  return (
    <section id="partners" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#6B2C91] font-semibold text-sm uppercase tracking-wider">
            Nos Partenaires
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-gray-900">
            Un Écosystème en Constante Expansion
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            8 banques partenaires, 3 filiales EKIP, et bientôt plus de 500 points d'acceptation.
          </p>
        </div>

        {/* EKIP Ecosystem */}
        <div className="mb-16">
          <h3 className="text-xl font-bold text-gray-900 mb-8 text-center">L'Écosystème EKIP</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {partners.ecosystem.map((partner, index) => (
              <Card
                key={index}
                className="group relative overflow-hidden border-0 shadow-lg hover:shadow-xl transition-all duration-300 p-6"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-24 h-24 bg-white rounded-2xl shadow-md flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="w-20 h-20 object-contain"
                    />
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">{partner.name}</h4>
                  <p className="text-sm text-gray-600">{partner.description}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Banks Grid */}
        <div className="mb-16">
          <h3 className="text-xl font-bold text-gray-900 mb-8 text-center">Banques Partenaires</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {partners.banks.map((bank, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-xl p-4 flex flex-col items-center justify-center text-center hover:bg-gray-100 transition-colors"
              >
                <Building2 className="w-8 h-8 text-[#0066CC] mb-2" />
                <h4 className="font-medium text-gray-900 text-sm">{bank.name}</h4>
                <p className="text-xs text-gray-500">{bank.agencies} agences</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-6">
            <p className="text-lg font-semibold text-[#6B2C91]">
              Total : 550+ Agences à Travers la Côte d'Ivoire
            </p>
          </div>
        </div>

        {/* Become Partner CTA */}
        <Card className="bg-gradient-to-r from-gray-900 to-gray-800 border-0 p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                Devenir Partenaire KIPAY
              </h3>
              <p className="text-gray-300 mb-6">
                Vous êtes commerçant ou entreprise ? Rejoignez notre réseau 
                et bénéficiez de l'accès à la base clients EKIP.
              </p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-center text-gray-300 text-sm">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center mr-2">
                    <span className="text-white text-xs">1</span>
                  </div>
                  Système de paiement sécurisé
                </li>
                <li className="flex items-center text-gray-300 text-sm">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center mr-2">
                    <span className="text-white text-xs">2</span>
                  </div>
                  Commission attractive
                </li>
                <li className="flex items-center text-gray-300 text-sm">
                  <div className="w-5 h-5 bg-[#00C853] rounded-full flex items-center justify-center mr-2">
                    <span className="text-white text-xs">3</span>
                  </div>
                  Intégration facile (API, terminal)
                </li>
              </ul>
              <Button
                size="lg"
                className="bg-[#FFD700] hover:bg-[#e6c200] text-gray-900 font-semibold px-8 group"
              >
                Devenir Partenaire
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
            <div className="hidden md:flex items-center justify-center">
              <div className="relative">
                <div className="w-48 h-48 bg-[#6B2C91]/20 rounded-full flex items-center justify-center">
                  <div className="w-32 h-32 bg-[#6B2C91]/40 rounded-full flex items-center justify-center">
                    <Users className="w-16 h-16 text-white" />
                  </div>
                </div>
                <div className="absolute -top-4 -right-4 w-16 h-16 bg-[#FFD700] rounded-full flex items-center justify-center shadow-lg">
                  <span className="text-gray-900 font-bold text-xl">+</span>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default Partners;
